import { useEsitoListSorted, useInfoAggiuntivaData } from 'features/sport/hooks';
import { ScommesseEsitoTipoCard } from 'components/scommesseEsitoTipoCard';
import { ScommesseGridMultiple } from 'components/scommesseTipo/wrappers/scommesseGridMultiple';
import { isTruthy } from 'utility/functions';
import { ScommesseLeafItem } from 'components/scommesseTipo/components/cells';
import { ScommesseTipoProps } from 'components/scommesseTipo/types';

export type OverThreeEstesaItemProps = ScommesseTipoProps & {
  index: number;
  infoAggiuntivaKey: string;
};

export const OverThreeEstesaItem = ({
  index,
  infoAggiuntivaKey,
  gtagAction,
  scommessaKey,
}: OverThreeEstesaItemProps) => {
  const esitoKeyList = useEsitoListSorted(infoAggiuntivaKey);
  const infoAggData = useInfoAggiuntivaData(infoAggiuntivaKey);
  const { valore, isBilanciata } = infoAggData ?? {};

  return (
    <ScommesseGridMultiple.Row key={esitoKeyList?.join('_')} index={index}>
      {esitoKeyList?.map((keyEsito) => (
        <ScommesseEsitoTipoCard
          type={ScommesseLeafItem.Quota}
          key={keyEsito}
          keyEsito={keyEsito}
          infoAggiuntivaKey={infoAggiuntivaKey}
          isBalanced={isTruthy(isBilanciata)}
          backgroundType="secondary"
          additionalText={valore}
          gtagAction={gtagAction}
          scommessaKey={scommessaKey}
        />
      ))}
    </ScommesseGridMultiple.Row>
  );
};